import { render, staticRenderFns } from "./DisplayPhoneOptions.vue?vue&type=template&id=4a71be83&"
import script from "./DisplayPhoneOptions.vue?vue&type=script&lang=js&"
export * from "./DisplayPhoneOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports